<template>
  <!--  Top menu -->
  <nav
    id="mainNav"
    class="navbar navbar-expand-md navbar-dark fixed-top"
    :class="$route.path === '/home' ? '' : 'bg-primary'"
  >
    <!-- <div class="rtl-layout" @click="addToggleClass()"><a href="javascript:void(0);">RTL</a></div> -->
    <div class="container">
      <router-link
        class="navbar-brand"
        to="/home"
        routerLinkActive="active-link"
      >
        <img
          src="/static/img/christianLibrary.png"
          class="img-fluid"
          width="110"
          height="37"
        />
      </router-link>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarCollapse"
        aria-controls="navbarCollapse"
        aria-expanded="true"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul id="main" class="navbar-nav ml-auto main-menu list-unstyled">
          <li
            @click="menuToggleLink('menuNo' + i)"
            class="parent nav-item"
            v-for="(menuItem, i) in menus"
            :id="'menuNo' + i"
            :key="i"
          >
            <router-link
              class="nav-link"
              :to="menuItem.state"
              v-if="menuItem.type == 'link'"
              @click.native="removeCollapseInClass()"
            >
              {{ $t(menuItem.name) }}
            </router-link>
            <a v-if="menuItem.type == 'sub'" class="nav-link">
              {{ $t(menuItem.name) }}&nbsp;
              <i
                :class="menuItem.icon"
                @click.stop="menuToggle('menuNo' + i)"
              ></i>
            </a>
            <ul
              v-if="menuItem.type == 'sub' && menuItem.children"
              class="sub-menu arrow-up list-unstyled"
            >
              <li
                class="nav-item"
                v-for="(grandchildItem, i) of menuItem.children"
                :key="i"
              >
                <router-link
                  class="nav-link"
                  :to="grandchildItem.state"
                  v-if="grandchildItem.type == 'link'"
                  @click.native="removeCollapseInClass()"
                >
                  <i :class="grandchildItem.icon"></i>
                  {{ $t(grandchildItem.name) }}
                </router-link>
              </li>
            </ul>
          </li>
          <!-- <li>
            <div class="search-form" click-outside>
              <span data-target="#search-style-simple" @click="showSearch()">
                <i class="fa fa-search"></i>
              </span>
              <div
                class="module-container"
                :class="{ 'search-active': searchactive }"
                id="search-style-simple"
              >
                <form
                  role="search"
                  method="get"
                  class="search-box"
                  action="javascript:void(0);"
                >
                  <input
                    type="search"
                    class="form-control"
                    placeholder="Search"
                    value=""
                    name=""
                  />
                  <button type="submit"><i class="fa fa-search"></i></button>
                </form>
              </div>
            </div>
          </li> -->
          <li>
            <span class="badge badge-light text-primary">{{
              this.$i18n.locale
            }}</span>
            /
            <span
              class="badge badge-none text-white"
              @click="ChangeLocale('ar')"
              v-if="CurrentLang == 'en'"
              >Ar</span
            >
            <span
              class="badge badge-none text-white"
              @click="ChangeLocale('en')"
              v-if="CurrentLang == 'ar'"
              >EN</span
            >
          </li>
          <li v-if="appActiveUser.Token">
            <div class="dropdown">
              <a class="text-white mx-2" v-if="appActiveUser.Token">{{
                appActiveUser.FullName
              }}</a>

              <img
                :src="ProfilePic"
                class="Circle rounded-circle z-depth-2 dropdown-toggle"
                alt="100x100"
                id="dropdownMenu2"
                data-toggle="dropdown"
                aria-haspopup="true"
                aria-expanded="false"
                data-holder-rendered="true"
              />

              <div class="dropdown-menu" aria-labelledby="dropdownMenu2">
                <router-link
                  class="navbar-brand col"
                  to="/editProfile"
                  routerLinkActive="active-link"
                >
                  <button class="dropdown-item" type="button">
                    {{ $t("EditProfile") }}
                  </button>
                </router-link>
                <router-link
                  class="navbar-brand col"
                  to="/changePassword"
                  routerLinkActive="active-link"
                >
                  <button class="dropdown-item" type="button">
                    {{ $t("ChangePassword") }}
                  </button>
                </router-link>
                <button class="dropdown-item" type="button" @click="logout">
                  {{ $t("Logout") }}
                </button>
              </div>
            </div>
          </li>
          <li v-else>
            <router-link
              :to="{
                path: '/login',
              }"
            >
              {{ $t("Login") }}
            </router-link>
            <router-link
              :to="{
                path: '/signup',
              }"
            >
              /
              {{ $t("SignUp") }}
            </router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { domain } from "@/globalComponents.js";

export default {
  data() {
    return {
      searchactive: false,
      baseURL: domain,
      menus: [
        {
          state: "/home",
          name: "Home",
          type: "link",
        },
        {
          state: "/",
          name: "Read & Listen",
          type: "sub",
          icon: "fa fa-caret-down",
          children: [
            {
              state: "/books",
              name: "Books",
              type: "link",
              icon: "fa fa-book-open",
            },
            {
              state: "/audios",
              name: "Audios",
              type: "link",
              icon: "fa fa-volume-up",
            },
            {
              state: "/videos",
              name: "Videos",
              type: "link",
              icon: "fa fa-video",
            },
          ],
        },
        {
          state: "/blogs",
          name: "Blogs",
          type: "link",
        },
        {
          state: "/news",
          name: "News",
          type: "link",
        },
        {
          state: "/Favorites",
          name: "Favorite",
          type: "link",
        },
        {
          state: "/About",
          name: "About",
          type: "link",
        },
      ],
    };
  },
  mounted() {
    this.onScrollEvent();
  },
  computed: {
    CurrentLang() {
      return this.$i18n.locale;
    },
    appActiveUser() {
      return this.$store.state.AppActiveUser;
    },
    ProfilePic() {
      let pic = "/static/img/christianLibrary.png";
      if (this.$store.state.AppActiveUser.ProfilePicURL) {
        if (this.$store.state.AppActiveUser.ProfilePicURL.includes("http")) {
          pic = this.$store.state.AppActiveUser.ProfilePicURL;
        } else {
          pic = this.baseURL + this.$store.state.AppActiveUser.ProfilePicURL;
        }
      }
      return pic;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch("auth/logout");
    },
    ChangeLocale(locale) {
      this.$i18n.locale = locale;
      localStorage.setItem("SaveLang", locale);
      if (locale === "ar") {
        document.querySelector("body").classList.toggle("rtl-enable");
        location.reload("/");
        // this.ChangeUserLanguage(2);
      } else {
        document.querySelector("body").classList.toggle("rtl-enable");
        location.reload("/");

        // this.ChangeUserLanguage(3);
      }
    },
    showSearch() {
      this.searchactive = !this.searchactive;
    },
    menuToggleLink(id) {
      if (document.getElementById(id).classList.contains("open")) {
        document.getElementById(id).classList.remove("open");
      } else if (!document.getElementById(id).classList.contains("open")) {
        let elements = document.querySelectorAll(".parent");
        for (var i = 0; i < elements.length; i++) {
          elements[i].classList.remove("open");
        }
        document.getElementById(id).classList.add("open");
      }
    },
    addToggleClass() {
      document.querySelector("body").classList.toggle("rtl-enable");
    },
    removeCollapseInClass() {
      document.getElementById("navbarCollapse").classList.remove("show");
    },
    onScrollEvent() {
      var headerSticky = document.getElementById("mainNav");
      window.onscroll = function() {
        if (window.pageYOffset >= 100) {
          headerSticky.classList.add("scrollHeader");
        } else {
          headerSticky.classList.remove("scrollHeader");
        }
      };
    },
  },
  created() {},
};
</script>
<style>
.scrollHeader {
  background-color: #f78500;
}
.Circle {
  width: 60px !important;
  height: 60px !important ;
}
</style>
